/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_A1dInputs */

const en_mk_sol_konsultan_a1d = /** @type {(inputs: Mk_Sol_Konsultan_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summarises documents, does the arithmetic, and always says where a number came from.`)
};

const id_mk_sol_konsultan_a1d = /** @type {(inputs: Mk_Sol_Konsultan_A1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merangkum dokumen, menghitung, dan selalu menyebutkan dari mana angkanya berasal.`)
};

/**
* | output |
* | --- |
* | "Summarises documents, does the arithmetic, and always says where a number came from." |
*
* @param {Mk_Sol_Konsultan_A1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_a1d = /** @type {((inputs?: Mk_Sol_Konsultan_A1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_A1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_a1d(inputs)
	return en_mk_sol_konsultan_a1d(inputs)
});